module.exports = __webpack_public_path__ + "img/recovery-success.62e532ee.svg";